import { WebSocketEvent } from "@/services/webSocketEvent";
import { useVenuesDataStore } from "@/store/useVenuesDataStore";
import { socketService } from "@/services/socket.service";
import type { Guest } from "@/types/order";

export type WebSocketTableDataType = {
  totalAmount: number;
  paidGuests: Guest[];
  paidAmount: number;
  remainingGuests: Guest[];
  remainingAmount: number;
  tableNumber?: number;
};

const handleTablesData = (data: WebSocketTableDataType) => {
  if (data) {
    useVenuesDataStore.getState().setVenuesData({
      totalAmount: data.totalAmount,
      paidGuests: data.paidGuests,
      paidAmount: data.paidAmount,
      remainingGuests: data.remainingGuests,
      remainingAmount: data.remainingAmount,
      ...(data.tableNumber != null && { tableNumber: data.tableNumber }),
    });
  }
};

const handleException = (error: unknown) => {
  console.error("WebSocket exception:", error);
};

export const subscribeToTablesEvents = () => {
  socketService.on(WebSocketEvent.TABLES_PUBLIC_INIT, handleTablesData);
  socketService.on(WebSocketEvent.TABLES_PUBLIC_UPDATE, handleTablesData);
  socketService.on(WebSocketEvent.EXCEPTION, handleException);
};

export const unsubscribeFromTablesEvents = () => {
  socketService.off(WebSocketEvent.TABLES_PUBLIC_INIT, handleTablesData);
  socketService.off(WebSocketEvent.TABLES_PUBLIC_UPDATE, handleTablesData);
  socketService.off(WebSocketEvent.EXCEPTION, handleException);
};

export const getTablesData = () => {
  return useVenuesDataStore.getState();
};
